import React from 'react';
import { Flag, Mail, MapPin, Phone, Facebook, Twitter, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-950 pt-16 pb-8 border-t-4 border-pac-red text-slate-300" data-id="element-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-51">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-52">
          {/* Brand & Info */}
          <div className="col-span-1 md:col-span-2" data-id="element-53">
            <div className="flex items-center gap-2 mb-6" data-id="element-54">
              <Flag className="h-8 w-8 text-pac-gold" data-id="element-55" />
              <div className="flex flex-col" data-id="element-56">
                <span className="font-serif font-bold text-2xl leading-tight text-white tracking-wide uppercase" data-id="element-57">
                  West Valley
                </span>
                <span className="text-xs font-sans font-semibold text-pac-gold tracking-[0.2em] uppercase" data-id="element-58">
                  Leadership PAC
                </span>
              </div>
            </div>
            <p className="text-slate-400 mb-6 max-w-md leading-relaxed" data-id="element-59">
              Dedicated to preserving local control, advocating for smart zoning
              laws, and ensuring a high quality of life for all residents in the
              West Valley of Maricopa County.
            </p>
            <div className="flex gap-4" data-id="element-60">
              <a href="#" className="bg-slate-800 p-2 rounded hover:bg-pac-blue hover:text-white transition-colors" data-id="element-61">
                <Facebook className="h-5 w-5" data-id="element-62" />
              </a>
              <a href="#" className="bg-slate-800 p-2 rounded hover:bg-pac-blue hover:text-white transition-colors" data-id="element-63">
                <Twitter className="h-5 w-5" data-id="element-64" />
              </a>
              <a href="#" className="bg-slate-800 p-2 rounded hover:bg-pac-blue hover:text-white transition-colors" data-id="element-65">
                <Instagram className="h-5 w-5" data-id="element-66" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-67">
            <h4 className="text-white font-serif font-bold text-lg mb-6 uppercase tracking-wider" data-id="element-68">
              Quick Links
            </h4>
            <ul className="space-y-3" data-id="element-69">
              <li data-id="element-70">
                <a href="#mission" className="hover:text-pac-gold transition-colors" data-id="element-71">
                  Our Mission
                </a>
              </li>
              <li data-id="element-72">
                <a href="#issues" className="hover:text-pac-gold transition-colors" data-id="element-73">
                  Key Issues
                </a>
              </li>
              <li data-id="element-74">
                <a href="#leadership" className="hover:text-pac-gold transition-colors" data-id="element-75">
                  Board of Directors
                </a>
              </li>
              <li data-id="element-76">
                <a href="#news" className="hover:text-pac-gold transition-colors" data-id="element-77">
                  News & Updates
                </a>
              </li>
              <li data-id="element-78">
                <a href="#donate" className="text-pac-red font-bold hover:text-red-400 transition-colors" data-id="element-79">
                  Contribute
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-80">
            <h4 className="text-white font-serif font-bold text-lg mb-6 uppercase tracking-wider" data-id="element-81">
              Contact
            </h4>
            <ul className="space-y-4" data-id="element-82">
              <li className="flex items-start gap-3" data-id="element-83">
                <MapPin className="h-5 w-5 text-pac-gold shrink-0 mt-0.5" data-id="element-84" />
                <span data-id="element-85">
                  1234 Civic Center Plaza
                  <br data-id="element-86" />
                  Surprise, AZ 85374
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-87">
                <Phone className="h-5 w-5 text-pac-gold shrink-0" data-id="element-88" />
                <span data-id="element-89">(623) 555-0198</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-90">
                <Mail className="h-5 w-5 text-pac-gold shrink-0" data-id="element-91" />
                <span data-id="element-92">info@westvalleypac.org</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Compliance & Copyright */}
        <div className="border-t border-slate-800 pt-8 flex flex-col items-center text-center" data-id="element-93">
          <div className="border-2 border-slate-700 p-4 mb-6 max-w-3xl w-full" data-id="element-94">
            <p className="text-sm font-bold text-slate-400 uppercase tracking-wider" data-id="element-95">
              Paid for by West Valley Leadership PAC. Not authorized by any
              candidate or candidate's committee.
            </p>
          </div>
          <p className="text-xs text-slate-500 max-w-3xl mb-4" data-id="element-96">
            Contributions to West Valley Leadership PAC are not deductible as
            charitable contributions for federal income tax purposes. Federal
            law requires us to use our best efforts to collect and report the
            name, mailing address, occupation, and name of employer of
            individuals whose contributions exceed $200 in a calendar year.
          </p>
          <p className="text-xs text-slate-600" data-id="element-97">
            &copy; {new Date().getFullYear()} West Valley Leadership PAC. All
            rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}